export const CREATE_CAMPAIGN_BTN_TEST_ID = 'node-editor-create-campaign-btn';
export const UPDATE_CAMPAIGN_BTN_TEST_ID = 'node-editor-update-campaign-btn';
export const EDIT_CAMPAIGN_BTN_TEST_ID = 'node-editor-edit-campaign-btn';
